// extracted by mini-css-extract-plugin
export default {"button":"style_button__fOqeQ","button__title":"style_button__title__8Zbp-","button__right-icon":"style_button__right-icon__NRLzm"};